import{create_ssr_component as t,subscribe as o,escape as e}from"svelte/internal";import{p as $}from"../../chunks/stores.js";const b=t((a,n,u,c)=>{let r,s;return s=o($,p=>r=p),s(),`<h1>${e(r.status)}</h1> <p>${e(r.error?.message)}</p>`});export{b as default};
//# sourceMappingURL=error.svelte.js.map
